/**
 * @file src/pages/client-management/components/LoadingSkeleton.jsx
 * @description Loading placeholder for the Client Management page.
 */

import React from "react";

const LoadingSkeleton = ({ isCollapsed }) => (
  <div
    className={`transition-all duration-300 ease-in-out ${
      isCollapsed ? "md:ms-16" : "md:ms-64"
    }`}
  >
    <main className="p-4 md:p-6">
      <div className="animate-pulse">
        <div className="mb-8">
          <div className="h-8 bg-muted rounded w-56 mb-2" />
          <div className="h-4 bg-muted rounded w-80" />
        </div>
        <div className="grid grid-cols-4 gap-4 mb-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-20 bg-muted rounded-xl" />
          ))}
        </div>
        <div className="bg-card rounded-xl p-6 border border-border mb-6">
          <div className="h-12 bg-muted rounded" />
        </div>
        <div className="bg-card rounded-xl shadow-sm border border-border">
          <div className="p-6">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="h-14 bg-muted rounded mb-2" />
            ))}
          </div>
        </div>
      </div>
    </main>
  </div>
);

export default LoadingSkeleton;
